import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
// import * as d3 from 'd3';
import { Chart } from 'chart.js';
@Component({
  selector: 'ipm-line',
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.scss']
})
export class LineComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() chartId: string = "";
  @Input() chartData: any = "";
  @Input() selectedTabData: any = "";
  @Input() rendertype: any = "";

  @ViewChild('chartCanvas') canvasRef?: ElementRef<HTMLCanvasElement>;

  private chart?: Chart;

  makeBarChart () {
    let chartOptions: any = {
      type: 'line',
      data: {
      datasets: [{
        label: 'My First Dataset',
        borderColor: '#B998FF',
        tension: 0.1,
        fill: true,
        strokeColor : "#B998FF",
        pointColor : "#B998FF",
        pointStrokeColor : "#B998FF",
        pointHighlightFill: "#B998FF",
        pointHighlightStroke: "#B998FF",
      }]},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            beginAtZero: true,
              grid: {
                display: false,
                tickWidth: 1,
                drawOnChartArea: true,
                drawTicks: true,
                lineWidth:1
              },
              ticks: { 
                color: "rgba(255, 255, 255, 1)",
                font:"20"
              }
          },
          y: {
            beginAtZero: true,
              grid: {
                display: true,
                tickWidth: 1,
                lineWidth:1
              },
              ticks: { 
                color: "rgba(255, 255, 255, 1)",
                font:"20"
              }
          }
        },
        elements: {
          point:{
              radius: 0
          }
        },
        plugins: {
          title: {
            display: false,
            text: 'Custom Chart Title'
        },
          legend: { 
            display: false 
          },
          tooltip: { usePointStyle: true }
        },
        interaction: { mode: 'index', intersect: false },
      }
    }
    if (this.chartData) {
      let labels: Array<any> = [];
      let data: Array<any> = [];
      if (this.rendertype === "camp") {
        this.chartData.map((chartOp: any) => {
          let dateLable = new Date(chartOp.date + 'T00:00:00').toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
          })
          labels.push(dateLable);
          data.push(chartOp[this.selectedTabData.key])
        });
        chartOptions.data.datasets[0].label =  this.selectedTabData?.value;
      } else {
        this.chartData.map((chartOp: any) => {
          labels.push(chartOp.date);
          data.push(chartOp.count)
        });
      }
      chartOptions.data.labels =  labels;
      chartOptions.data.datasets[0].data =  data;
    }
    return chartOptions;
  }

  constructor() { }

  ngOnInit(): void {
    // if () {
    //   this.ctx = (document.getElementById('lineChart') as HTMLElement).getContext('2d'); // 2d context
    //   this.ctx = $('#lineChart'); // jQuery instance
    //   this.ctx = 'myChart';
    // }
  }

  ngAfterViewInit(): void {
    this.prepareChatData();
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change['selectedTabData'] || change['chartData']) {
      this.prepareChatData();
    }
  }

  prepareChatData() {
    // use the canvas element reference (the id is dynamic and may not be
    // re-rendered in the DOM yet when ngOnChanges fires on a toggle)
    const canvas = this.canvasRef?.nativeElement;
    if (!canvas) {
      return;
    }
    let lineChartOption: any = this.makeBarChart();
    let finalChart = canvas.getContext("2d");
    if (finalChart) {
      let gradient = finalChart.createLinearGradient(0, 0, 0, 400);
      gradient.addColorStop(0, 'rgba(185,152,255, 0.4)');
      gradient.addColorStop(1, 'rgba(125, 46, 186, 0.02)');
      lineChartOption.data.datasets[0]['backgroundColor'] = gradient;
    }
    if (this.chart) {
      // update the existing chart in place so the toggle transition animates
      // smoothly — destroy + re-create would discard the chart and kill the
      // animation, making the new data just snap in
      this.chart.data.labels = lineChartOption.data.labels;
      this.chart.data.datasets[0].data = lineChartOption.data.datasets[0].data;
      this.chart.data.datasets[0].label = lineChartOption.data.datasets[0].label;
      this.chart.data.datasets[0].backgroundColor = lineChartOption.data.datasets[0].backgroundColor;
      this.chart.update();
    } else {
      this.chart = new Chart(canvas, lineChartOption);
    }
  }

  ngOnDestroy(): void {
    this.chart?.destroy();
  }
}
